import React, { memo, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CopilotContext } from '@Sage/ssm-web5';

import { ConfigActions } from 'actions';
import TabLoader from 'containers/TabLoader';

const mapDispatchToProps = (dispatch) => {
    return {
        logout: bindActionCreators(ConfigActions, dispatch).logout,
    };
};

const Logout = ({ logout }) => {
    const { clearAllChats } = useContext(CopilotContext);

    useEffect(() => {
        logout();
        clearAllChats();
    }, [logout, clearAllChats]);

    return <TabLoader />;
};

export default memo(connect(null, mapDispatchToProps)(Logout));
